<h2 mat-dialog-title>Chọn chi nhánh làm việc</h2>
<div mat-dialog-content>
    <p>Vui lòng chọn chi nhánh bạn muốn làm việc:</p>
    <mat-selection-list #subsidiaryList [multiple]="false">
        <mat-list-option *ngFor="let sub of subsidiaries" [value]="sub.id">
            {{ sub.name }}
        </mat-list-option>
    </mat-selection-list>
</div>
<div mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="null">Hủy</button>
    <button mat-raised-button color="primary" [disabled]="!subsidiaryList.selectedOptions.selected.length"
        [mat-dialog-close]="subsidiaryList.selectedOptions.selected[0].value">
        Chọn
    </button>
</div>